var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"id":"verifyMail","type":"submit"},on:{"click":function($event){return _vm.sendMail()}}},[_vm._v("Enviar E-mail")])])}
var staticRenderFns = []

export { render, staticRenderFns }